/******/ (() => { // webpackBootstrap
class CartRecommendations extends HTMLElement {
  constructor() {
    super();
    this.recommendationsDrawer = this.closest('[data-cart-drawer-recommendations]');
    this.fetchRecommendations = this.fetchRecommendations.bind(this);
    this.renderRecommendations = this.renderRecommendations.bind(this);
  }

  connectedCallback() {
    window.wetheme.webcomponentRegistry.register({key: 'component-cart-recommendations'});
    this.fetchRecommendations();
  }

  async fetchRecommendations() {
    if (!this.url) return;

    try {
      /* ===== Dr. Oldhaver: zuerst die Ergänzungsprodukte (Search & Discovery) aller Artikel im Warenkorb,
         danach Shopifys verwandte Produkte zum teuersten Artikel als Auffüllung. Doppelte und mehr als 6 Karten entfallen.
         Hintergrund: „Verwandte Produkte“ wirken auch im Live-Theme, „Ergänzungsprodukte“ nicht. ===== */
      const cart = await fetch('/cart.js').then((r) => r.json()).catch(() => null);
      const ids = cart ? [...new Set(cart.items.map((i) => i.product_id))].slice(0, 4) : [];
      const compUrls = ids.map((id) => this.url.replace(/product_id=\d+/, 'product_id=' + id) + '&intent=complementary');
      const texts = await Promise.all(
        [...compUrls, this.url].map((u) => fetch(u).then((r) => (r.ok ? r.text() : '')).catch(() => ''))
      );

      const parser = new DOMParser();
      const seen = new Set();
      const cards = [];
      texts.forEach((t) => {
        if (!t) return;
        const grid = parser.parseFromString(t, 'text/html').querySelector('cart-recommendations .cart-drawer__recommendations-grid');
        if (!grid) return;
        [...grid.children].forEach((card) => {
          const link = card.querySelector('a[href*="/products/"]');
          const key = link ? link.getAttribute('href').split('?')[0] : card.outerHTML;
          if (seen.has(key) || cards.length >= 6) return;
          seen.add(key);
          cards.push(card.outerHTML);
        });
      });

      const html = cards.length
        ? '<cart-recommendations><div class="cart-drawer__recommendations-grid">' + cards.join('') + '</div></cart-recommendations>'
        : '<cart-recommendations></cart-recommendations>';
      this.renderRecommendations(html);
    } catch (error) {
      console.error(`Failed to fetch cart drawer:`, error);
    }
  }

  renderRecommendations(html) {
    const updatedContent = new DOMParser().parseFromString(html, 'text/html').querySelector('cart-recommendations')?.innerHTML;
    
    if (!updatedContent || updatedContent.trim().length === 0) {
      /* ===== If no recommendations, hide the secondary drawer ===== */
      this.closest('cart-drawer')?.classList.add('hide-recommendations');
    } else {
      /* ===== If recommendations, update content ===== */
      this.innerHTML = updatedContent;
      this.closest('cart-drawer')?.classList.remove('hide-recommendations');

      /* ===== Prevent mobile content shift with each fetch by fixing the parent height and re-calculating after each fetch ===== */
      if (window.matchMedia('only screen and (max-width: 767px)').matches) {
        this.parentElement.style.height = 'auto';
        this.parentHeight = this.parentElement.getBoundingClientRect().height;
        this.parentElement.style.height = '';
        document.documentElement.style.setProperty('--cart-recommendations-height', `${this.parentHeight}px`);
      }
    }
  }

  get url() {
    return this.getAttribute('data-cart-recommendations-url');
  }
}

customElements.define('cart-recommendations', CartRecommendations);
/******/ })()
;